import campaignConfig from '../../../../../campaign-config/campaign.json';

export const globalColors = campaignConfig.global?.colors || {};
export const globalBackgrounds = campaignConfig.global?.backgrounds || {};

export const tutorDetailsMilestonesConfig =
  campaignConfig.tutor_details?.milestones || {};

export const resolveTutorDetailsMilestonesAsset = (asset) => asset;